module.exports = __webpack_public_path__ + "static/The_crown_estate_blue-51c3b7cc7a18ef7a98b38dd8cdaf5cf7.png";